import { ApiService } from "@/api";

export default {
  GET_PRIORITIES({ commit }, payload) {
    return ApiService.priorities
      .getPrioritiesList({
        page: payload.page,
        count: payload.count,
      })
      .then((data) => {
        commit("SET_LIST_PRIORITIES", data);
        return data;
      });
  },
  ADD_PRIORITY(context, priority) {
    return ApiService.priorities
      .addPriority(priority)
      .then((data) => {
        return data;
      });
  },
  REMOVE_PRIORITY_TRANSACTION(context, idTransaction) {
    return ApiService.priorities
      .removeTransaction(idTransaction)
      .then((data) => {
        return data;
      });
  }
};
